<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body">
                        <date-pick v-model="date" :hasInputElement="false">
                        </date-pick>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-default-button" @click="$emit('close')">
                                Zeitraum auswählen
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import DatePick from 'vue-date-pick';
    import 'vue-date-pick/dist/vueDatePick.css';

    export default {
        components: {
            DatePick
        },
        data: () => ({
            date: '2019-01-01-2019-01-03',
            showModal: false
        })
    };


</script>

<style lang="scss">
    @import '../../assets/css/style';
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .7);
        display: block;
        transition: opacity .5s ease;
        margin-top: 60px;
    }

    .modal-wrapper {
        display: block;
        margin-top: 15px;

    }

    .modal-container {
        width: 92%;
        height: 72vh;
        margin: 0px auto;
        padding: 20px 0 !important;
        background-color: $model-container_background;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        overflow: hidden;
        border-radius: 4px;
        position: relative;
    }


    .modal-body {
        margin: 30px 0;
        width: 100%;
        padding: 0;
        border: none;
    }

    .modal-default-button {
        margin: auto;
    }

    .modal-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        button{
            color:$button_full_backGroundColor;
            background-color: $button_full_color;
            border: none;
            font-size: 1.6rem;
            font-weight: 700;
        }
    }


    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .vdpHeader {
        background-color: $button_full_color;
    }

    .vdpInnerWrap {
        box-shadow: none;
        border: none;
    }

    .vdpCell.selectable:hover .vdpCellContent,
    .vdpCell.selected .vdpCellContent {
        background: $button_full_backGroundColor;
    }

    .vdpCell.today {
        color: $button_full_backGroundColor;
    }

    .vdpTimeUnit > input:hover,
    .vdpTimeUnit > input:focus {
        border-bottom-color: #cc99cd;
    }

</style>



// WEBPACK FOOTER //
// src/components/meine_trends/CalendarView.vue